import { createI18n } from 'vue-i18n'
import en from './locales/en.ts'
import et from './locales/et.ts'
import { useStorage } from '../services/storage'
import { useLanguageEvents } from '../composables/useLanguageEvents'

const { getItem, setItem } = useStorage()
const { emitLanguageChanged } = useLanguageEvents()

// Get the saved language from storage, or default to English
const savedLocale: string = getItem('language') || 'en'

// Type for translation messages - allowing nested objects
type MessageSchema = Record<string, any>

// Create a messages object with initial locales
const messages: Record<string, MessageSchema> = {
  en,
  et
}

// Create the i18n instance with support for dynamic locales
const i18n = createI18n({
  legacy: false, // Use the Composition API mode
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
  missingWarn: false, // Don't warn about missing translations
  fallbackWarn: false, // Don't warn when falling back to another language
  globalInjection: true, // Provide $t and $tc to all components
})

// Function to change the language
export function setLanguage(lang: string) {
  // Set the language in i18n
  i18n.global.locale.value = lang
  
  // Save the language preference
  setItem('language', lang)
  
  // Emit language change event using VueUse composable
  emitLanguageChanged(lang)
}

// Function to add a new locale dynamically
export function addLocale(lang: string, messages: MessageSchema) {
  i18n.global.setLocaleMessage(lang, messages)
}

export default i18n 